import { BookOpen, Users, Trophy } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardAction } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
const foundations = [{
  title: "Academic Excellence",
  badge: "Honors Scholar",
  icon: BookOpen,
  description: "In my time at St. Mary's I was an excellent student. Earning a 4.0 and numerous academic awards including but not limited to English Student of the year."
}, {
  title: "Student Leadership",
  badge: "Class President",
  icon: Users,
  description: "I was chosen to be a Kairos leader while in High School. This was our primary retreat where students were meant to find themselves, strengthen friendships, and build their relationship with God.\xA0"
}, {
  title: "Extracurriculars",
  badge: "Varsity Captain",
  icon: Trophy,
  description: "In my time at St. Mary's I participated on the Ski and Crew Team. I was chosen to be Capitan of the Ski team. I also won a Midwest Championship and finished 6th in the nation my junior year rowing."
}];
export default function HighSchool() {
  return <section id="high-school" className="dark bg-background text-foreground py-20 px-4 md:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="mb-12 max-w-2xl">
          <h2 className="text-3xl md:text-4xl font-serif font-bold tracking-tight mb-4">Orchard Lake St. Mary's</h2>
          <p className="text-muted-foreground text-base md:text-lg">I attended High School at Orchard Lake St. Mary's. In my time there I grew not only as a student but as a man.&nbsp;</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {foundations.map((item, i) => <Card key={i} data-index={i} className="bg-card border-border/40 shadow-sm hover:shadow-md transition-shadow duration-300">
              <CardHeader className="pb-4">
                <div className="mb-4 inline-flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
                  <item.icon className="size-5 text-primary" aria-hidden="true" />
                </div>
                <CardTitle className="text-lg font-semibold tracking-tight">
                  {item.title}
                </CardTitle>
                <CardAction>
                  <Badge variant="secondary" className="font-medium tracking-wide">
                    {item.badge}
                  </Badge>
                </CardAction>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-sm leading-relaxed text-muted-foreground">
                  {item.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}